import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "../../css/admin/adminMessageToUsers.css";

const MessageToolTip = ({ message, index }) => {
  const truncated =
    message.length > 100 ? message.slice(0, 100) + "..." : message;

  return (
    <OverlayTrigger
      placement="right"
      containerPadding={10}
      container={document.body}
      overlay={
        <Tooltip
          id={`tooltip-message-${index}`}
          className="custom-tooltip"
          style={{
            maxWidth: "300px",
            whiteSpace: "normal",
            textAlign: "justify !important",
            fontWeight: "normal !important",
            color: "red",
          }}
        >
          {message}
        </Tooltip>
      }
    >
      <span
        style={{
          cursor: "pointer",
          display: "inline-block",
          maxWidth: "300px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {truncated}
      </span>
    </OverlayTrigger>
  );
};

export default MessageToolTip;
